const columns = () => ([
  {
    title: 'Template name',
    dataIndex: 'name',
    key: 'name',
    width: '20%',
    align: 'center',
  },
  {
    title: 'Template question',
    dataIndex: 'title',
    key: 'title',
    customRender: ({ text }) => (`${text.length > 70 ? `${text.slice(0, 67)}...` : text}`),
  },
  {
    title: 'Template answer',
    dataIndex: 'description',
    key: 'description',
    customRender: ({ text }) => (`${text.length > 70 ? `${text.slice(0, 67)}...` : text}`),
  },
  {
    title: 'Template question mobile',
    dataIndex: 'titleMobile',
    key: 'titleMobile',
    customRender: ({ text }) => (`${text.length > 70 ? `${text.slice(0, 67)}...` : text}`),
  },
  {
    title: 'Template answer mobile',
    dataIndex: 'descriptionMobile',
    key: 'descriptionMobile',
    customRender: ({ text }) => (`${text.length > 70 ? `${text.slice(0, 67)}...` : text}`),
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    width: '10%',
    align: 'center',
  },
]);

export default columns;
